import { Button } from '@material-ui/core'
import { useStyles } from './style'
export function ButtonSecondary({ label, ...rest }) {
  const classes = useStyles()
  return (
    <Button color="secondary" {...rest} className={classes.button}>
      {label}
    </Button>
  )
}
